module.exports = __webpack_public_path__ + "static/theo-manifesto-huh_english-cc5d6f08aac490ff7df6c76183391950.gif";